import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Select } from 'primeng/select';
import { WebContentType } from 'src/app/shared/model/webcontenttype.model';
import { WebContentSearchDto } from 'src/app/web-content/shared/dto/web-content-search.dto';
import { WebContentDto } from 'src/app/web-content/shared/dto/web-content.dto';
import { WebContentTypeService } from 'src/app/web-content/shared/web-content-type.service';
import { WebContentService } from 'src/app/web-content/shared/web-content.service';
import { EcomItemDto } from '../shared/dto/ecom-item.dto';
import { EComWebContentEditComponent } from '../ecom-web-content-edit/ecom-web-content-edit.component';

@Component({
  selector: 'wl-ecom-item-edit-downloadable-web-content',
  templateUrl: './ecom-item-edit-downloadable-web-content.component.html',
  styleUrls: ['./ecom-item-edit-downloadable-web-content.component.less'],
    standalone: false
})
export class EComItemEditDownloadableWebContentComponent implements OnInit, OnChanges {
  @Input() eCommerceItem: EcomItemDto;
  @ViewChild('webContentDropdown') webContentDropdown: Select;
  @ViewChild(EComWebContentEditComponent) webContentEditComponent: EComWebContentEditComponent;
  webContents: WebContentDto[];
  webContentTypeId: number;
  webContentTypes: WebContentType[];

  constructor(private _webContentService: WebContentService, private _webContentTypeService: WebContentTypeService) {}

  ngOnInit(): void {
    this.loadWebContent();
    this.loadWebContentTypes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.eCommerceItem && this.webContents) {
      this.ensureWebContentTypeAccurate();
      this.webContentEditComponent.clearData();
    }
  }

  ensureWebContentTypeAccurate() {
    let webContent = this.webContents?.find((x) => x.ContentID == this.eCommerceItem.ContentId);
    if (webContent) {
      this.webContentTypeId = webContent.ContentTypeID;
    } else {
      this.clear();
    }
  }

  loadWebContentTypes() {
    this._webContentTypeService.getWebContentTypes().then((data) => {
      this.webContentTypes = [{ ContentType: 'None', ContentTypeID: 0 } as WebContentType, ...data.Result];
      this.ensureWebContentTypeAccurate();
      this.webContentDropdown.filterValue = this.webContentTypeId?.toString();
    });
  }

  loadWebContent() {
    this._webContentService.search({ PageNumber: 0, PageSize: 0, IncludeUrl: true } as WebContentSearchDto).then((data) => {
      this.webContents = [{ ContentTitle: 'None', ContentID: 0, ContentTypeID: 0 } as WebContentDto, ...data.Result];
      this.webContentDropdown.filterValue = this.webContentTypeId?.toString();
    });
  }

  clear() {
    this.webContentTypeId = 0;
    this.eCommerceItem.ContentId = 0;
  }

  webContentTypeChanged() {
    // this won't set the content record to 0, but instead force the dropdown to touch the binding, and set it to the first item in the list
    this.eCommerceItem.ContentId = 0;
  }

  selectUploadedWebContent(dto: WebContentDto) {
    this.loadWebContent();
    this.webContentTypeId = dto.ContentTypeID;
    this.eCommerceItem.ContentId = dto.ContentID;
  }
}
